import { render, staticRenderFns } from "./SelectedFolder.vue?vue&type=template&id=e45e51b0&"
import script from "./SelectedFolder.vue?vue&type=script&lang=js&"
export * from "./SelectedFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports